ixModuleRouting('impactx.printbutton', {
    '/printdocument/:formType/:language/:param1/:dbCacheStatus?/:fileName?': {
        template: '<ixa-print-dialog></ixa-print-dialog>',
    }
});